var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isMobile)?_c('div',{staticClass:"horizontal-container"},[_c('div',{ref:"scroll",staticClass:"scroll-wrapper"},[_c('div',{staticClass:"scroll-content"},[_vm._t("default")],2)])]):_c('div',{staticClass:"horizontal-container-mobile"},[_c('div',{staticClass:"scroll-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }